module.exports = __webpack_public_path__ + "media/images/front/programs/04-3198321ee89f4ba69cc19909627504bb.jpg";